module.exports = __webpack_public_path__ + "static/media/profile-image-placeholder.4492a88f.png";